module.exports = __webpack_public_path__ + "img/106.422bdd32.jpg";